import React from "react";

import { Card, Grid, Typography } from "@material-ui/core";
import { DELIVERY_TYPE } from "../../../config/constants";

import ApprovalRequestSlotDetailsForStandard from "./ApprovalRequestSlotDetailsForStandard";
import ApprovalRequestSlotDetailsForExpress from "./ApprovalRequestSlotDetailsForExpress";
import { isArrayValid, isEmptyOrNull, isNonEmptyObject } from "../../../utils/DataUtils";
import { getServicePropositionDeliveryType } from "../../../utils/helperFunctions";

interface ApprovalRequestSlotDataDetailsPageInterface {
  classes: any;
  slot_data_object_key: any;
  slot_data_object: any;
  serviceTypeName: any;
  stateObj?: any;
  slotBoxClass: any;
  servicePropositionList: any;
}

const ApprovalRequestSlotDataDetailsPage = (props: ApprovalRequestSlotDataDetailsPageInterface) => {
  const { classes, slot_data_object_key, slot_data_object, serviceTypeName, stateObj, slotBoxClass, servicePropositionList } = props;

  const renderSlotDetails = (slot: any, slot_data_object?: any) => {
    if (isEmptyOrNull(serviceTypeName)) {
      return null;
    }

    const deliveryType = getServicePropositionDeliveryType(servicePropositionList, serviceTypeName);
    switch (deliveryType) {
      case DELIVERY_TYPE.SLOT_BASED:
        return (
          <ApprovalRequestSlotDetailsForStandard
            classes={classes}
            slot_day_data={slot}
            slot_data_object_key={slot_data_object_key}
            {...(!isEmptyOrNull(slot_data_object) && { slot_data_object: slot_data_object })}
          />
        );
      case DELIVERY_TYPE.MINUTE_BASED:
        return (
          <ApprovalRequestSlotDetailsForExpress
            classes={classes}
            slot_day_data={slot}
            slot_data_object_key={slot_data_object_key}
            {...(!isEmptyOrNull(slot_data_object) && { slot_data_object: slot_data_object })}
          />
        );
      default:
        return null;
    }
  }

  const renderContent = () => {
    if (isArrayValid(stateObj)) {
      return stateObj.map((slot: any, slot_index: number) => (
        <Grid item xs={12} key={`${slot_index}-slot_index-stateObj-originalConfigTab-${slot?.id ?? ""}`} className={classes.slotsAccordionMaindiv}>
          {renderSlotDetails(slot)}
        </Grid>
      ));
    } else if (isNonEmptyObject(slot_data_object)) {
      return Object.keys(slot_data_object).map((slot_day_data: any, slot_day_data_index: any) => (
        <Grid item xs={12} key={`${slot_day_data_index}-slot_day_data_index-slot_data_object-${slot_day_data?.id ?? ""}`} className={classes.slotsAccordionMaindiv}>
          {renderSlotDetails(slot_day_data, slot_data_object)}
        </Grid>
      ))
    } else {
      return null;
    }
  }

  return (
    <Card className={slot_data_object_key === "slots" ? classes.slotsCarDivStyleOriginal : classes.slotsCarDivStyleRequested}>
      <Grid container spacing={0} className={classes.slotsCardGridStyle}>
        <Grid item xs={12} className={classes.approverDetailsMainSlotHeadingDivStyle}>
          <Typography className={slot_data_object_key === "slots" ? classes.approverDetailsHeadingValueOriginalSpanStyle : classes.approverDetailsHeadingValueRequestedSpanStyle}>
            {`${slot_data_object_key === "slots" ? "Slots - Original Record" : "Slots - New Requested"}`}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={0} className={slotBoxClass}>
        {renderContent()}
      </Grid>
    </Card>
  );
};

export default React.memo(ApprovalRequestSlotDataDetailsPage);
